export const CERTIFICATES_PAGE_SIZE = 25;
export const CERTIFICATES_TABLE_PAGE_SIZE = 10;

export const TAB_KEYS = {
  ISSUED: 'issued',
  HISTORY: 'history',
} as const;

export const ALERT_VARIANTS = {
  SUCCESS: 'success',
  DANGER: 'danger',
  WARNING: 'warning',
  INFO: 'info',
} as const;

export const MODAL_TITLES = {
  ERROR: 'Error',
} as const;
